import { gql } from 'graphql-tag'

export default gql`
  fragment BlockPartnerMetadataLazyFragment on BlockPartnerMetadata {
    sys {
      id
    }
    contentType: __typename
  }
`
